import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function GestionAvancement() {
    const [grades, setGrades] = useState({});
    const [gradesExistants, setGradesExistants] = useState([]);
    const [showGradeModal, setShowGradeModal] = useState(false);
    const [showIndiceModal, setShowIndiceModal] = useState(false);
    const [showAvancementList, setShowAvancementList] = useState(false);
    const [showHistoriqueModal, setShowHistoriqueModal] = useState(false);
    const [newGradeName, setNewGradeName] = useState('');
    const [newGradeEchelons, setNewGradeEchelons] = useState(1);
    const [pasAvancement, setPasAvancement] = useState('');
    const [salariesEligibles, setSalariesEligibles] = useState([]);
    const [historique, setHistorique] = useState([]);
    const [currentHistoriqueSalarie, setCurrentHistoriqueSalarie] = useState(null);

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    const fetchAllData = async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_grades_complets.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) setGrades(data.grades);
    };

    const fetchGradesExistants = async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_grades_existants.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) setGradesExistants(data.grades);
    };

    const handleCreateGrade = async () => {
        if (!newGradeName || newGradeEchelons < 1) {
            toast.error("Sélectionnez un grade et précisez le nombre d'échelons");
            return;
        }
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/creer_grade.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ grade: newGradeName, nbEchelons: newGradeEchelons })
        });
        const data = await res.json();
        if (data.success) {
            toast.success(data.message);
            fetchAllData();
            setShowGradeModal(false);
            setNewGradeName('');
            setNewGradeEchelons(1);
        }
    };

    const handleSaveIndices = async () => {
        const token = localStorage.getItem('token');
        const indices = [];
        Object.values(grades).forEach(gradeGroup => {
            gradeGroup.forEach(g => {
                if (g.indice !== undefined) indices.push({ id_grade: g.id_grade, indice: g.indice });
            });
        });
        const res = await fetch(`${API_BASE}/mettre_a_jour_indices.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ indices })
        });
        const data = await res.json();
        if (data.success) {
            toast.success('Indices mis à jour');
            fetchAllData();
            setShowIndiceModal(false);
        }
    };

    const lancerAvancement = async () => {
        const pas = parseInt(pasAvancement);
        if (isNaN(pas) || pas <= 0) {
            toast.error("Veuillez saisir un pas d'avancement valide (ex: 2)");
            return;
        }
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/simuler_avancement.php?pas=${pas}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
            setSalariesEligibles(data.salaries);
            setShowAvancementList(true);
        } else {
            toast.error(data.message);
        }
    };

    const arreterAvancement = () => {
        setShowAvancementList(false);
        setPasAvancement('');
        setSalariesEligibles([]);
    };

    const appliquerAvancement = async (idSalarie) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/appliquer_avancement.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ id_salarie: idSalarie })
        });
        const data = await res.json();
        if (data.success) {
            toast.success("Avancement appliqué");
            lancerAvancement();
        } else {
            toast.error(data.message);
        }
    };

    const voirHistorique = async (idSalarie, nomPrenom) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_historique_avancement.php?id_salarie=${idSalarie}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
            setHistorique(data.historique);
            setCurrentHistoriqueSalarie(nomPrenom);
            setShowHistoriqueModal(true);
        } else {
            toast.error("Erreur chargement historique");
        }
    };

    useEffect(() => {
        fetchAllData();
        fetchGradesExistants();
    }, []);

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold text-primary mb-6">📈 Avancement & promotion</h1>

            <div className="flex flex-wrap gap-4 mb-8">
                <button onClick={() => setShowGradeModal(true)} className="bg-purple-600 text-white px-5 py-2 rounded-xl shadow">
                    🆕 Créer un grade
                </button>
                <button
                    onClick={() => {
                        fetchAllData();
                        setShowIndiceModal(true);
                    }}
                    className="bg-amber-600 text-white px-5 py-2 rounded-xl shadow"
                >
                    💰 Définir indices
                </button>
            </div>

            {!showAvancementList ? (
                <div className="bg-white p-6 rounded-xl shadow mb-6">
                    <h2 className="text-lg font-bold mb-4">⏫ Lancer un avancement / promotion</h2>
                    <div className="flex items-center gap-4">
                        <input
                            type="number"
                            placeholder="Pas d'avancement (années)"
                            className="border p-2 rounded w-48"
                            value={pasAvancement}
                            onChange={(e) => setPasAvancement(e.target.value)}
                        />
                        <button onClick={lancerAvancement} className="bg-green-600 text-white px-5 py-2 rounded shadow">
                            Lancer l’avancement
                        </button>
                    </div>
                </div>
            ) : (
                <div className="bg-white p-6 rounded-xl shadow mb-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-bold">📋 Liste des éligibles (pas = {pasAvancement} an(s))</h2>
                        <button onClick={arreterAvancement} className="bg-red-600 text-white px-4 py-2 rounded shadow hover:bg-red-700">
                            Arrêter / Revenir
                        </button>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="p-2">Matricule</th>
                                    <th className="p-2">Nom</th>
                                    <th className="p-2">Prénom</th>
                                    <th className="p-2">Grade</th>
                                    <th className="p-2">Ancienneté</th>
                                    <th className="p-2">Progression</th>
                                    <th className="p-2">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salariesEligibles.map((s) => (
                                    <tr key={s.id_salarie} className="border-b">
                                        <td className="p-2">{s.matricule}</td>
                                        <td className="p-2">{s.nom}</td>
                                        <td className="p-2">{s.prenom}</td>
                                        <td className="p-2">{s.poste2}</td>
                                        <td className="p-2">{s.annees} an(s)</td>
                                        <td className="p-2">
                                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                                <div className="bg-green-600 h-2.5 rounded-full" style={{ width: `${s.pourcentage_progression}%` }}></div>
                                            </div>
                                            <span className="text-xs">{s.pourcentage_progression}%</span>
                                            <div className="text-xs">Prochain : {s.date_prochain_avancement}</div>
                                        </td>
                                        <td className="p-2">
                                            <button onClick={() => appliquerAvancement(s.id_salarie)} className="bg-green-600 text-white px-3 py-1 rounded text-sm mr-2">
                                                Appliquer
                                            </button>
                                            <button onClick={() => voirHistorique(s.id_salarie, `${s.prenom} ${s.nom}`)} className="bg-blue-600 text-white px-3 py-1 rounded text-sm">
                                                📜 Histo
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className="bg-white p-4 rounded-xl shadow">
                <h2 className="text-lg font-bold mb-3">📋 Grades & indices actuels</h2>
                {Object.keys(grades).map((grade) => (
                    <div key={grade} className="mb-3">
                        <div className="font-semibold text-blue-800">{grade}</div>
                        <div className="flex flex-wrap gap-2 text-sm">
                            {grades[grade].map((e) => (
                                <span key={e.id_grade} className="bg-gray-100 px-2 py-1 rounded">{e.echelon} : {e.indice ?? '?'}</span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {showGradeModal && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-xl w-96">
                        <h3 className="text-xl font-bold mb-3">➕ Créer un grade</h3>
                        <select className="w-full border p-2 rounded mb-2" value={newGradeName} onChange={e => setNewGradeName(e.target.value)}>
                            <option value="">-- Sélectionner un grade --</option>
                            {gradesExistants.map(grade => (
                                <option key={grade} value={grade}>{grade}</option>
                            ))}
                        </select>
                        <input
                            type="number"
                            placeholder="Nombre d'échelons"
                            className="w-full border p-2 rounded mb-4"
                            value={newGradeEchelons}
                            onChange={e => setNewGradeEchelons(parseInt(e.target.value))}
                        />
                        <div className="flex justify-end gap-2">
                            <button onClick={() => setShowGradeModal(false)} className="bg-gray-400 text-white px-4 py-1 rounded">Annuler</button>
                            <button onClick={handleCreateGrade} className="bg-purple-600 text-white px-4 py-1 rounded">Créer</button>
                        </div>
                    </div>
                </div>
            )}

            {showIndiceModal && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-xl w-full max-w-3xl max-h-[80vh] overflow-y-auto">
                        <h3 className="text-xl font-bold mb-4">💰 Indices par échelon</h3>
                        {Object.keys(grades).map((grade) => (
                            <div key={grade} className="mb-6 border-b pb-4">
                                <h4 className="font-bold text-lg text-blue-700 mb-2">{grade}</h4>
                                {grades[grade].map((e) => (
                                    <div key={e.id_grade} className="flex items-center gap-3 mb-2">
                                        <span className="w-28 font-medium">{e.echelon}</span>
                                        <input
                                            type="number"
                                            placeholder="Indice"
                                            className="border p-1 rounded w-32"
                                            value={e.indice || ''}
                                            onChange={(ev) => {
                                                const newVal = ev.target.value ? parseInt(ev.target.value) : null;
                                                setGrades(prev => ({
                                                    ...prev,
                                                    [grade]: prev[grade].map(eg => eg.id_grade === e.id_grade ? { ...eg, indice: newVal } : eg)
                                                }));
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                        <div className="flex justify-end gap-2 mt-4">
                            <button onClick={() => setShowIndiceModal(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button>
                            <button onClick={handleSaveIndices} className="bg-amber-600 text-white px-4 py-2 rounded">Enregistrer</button>
                        </div>
                    </div>
                </div>
            )}

            {showHistoriqueModal && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-xl w-full max-w-3xl max-h-[80vh] overflow-y-auto">
                        <h3 className="text-xl font-bold mb-4">📜 Historique avancement – {currentHistoriqueSalarie}</h3>
                        <table className="min-w-full text-sm border">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="p-2">Ancien grade</th>
                                    <th className="p-2">Ancien échelon</th>
                                    <th className="p-2">Nouveau grade</th>
                                    <th className="p-2">Nouvel échelon</th>
                                    <th className="p-2">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historique.map((h) => (
                                    <tr key={h.id_historique} className="border-b">
                                        <td className="p-2">{h.ancien_grade} ({h.ancien_echelon})</td>
                                        <td className="p-2">{h.ancien_indice}</td>
                                        <td className="p-2">{h.nouveau_grade} ({h.nouveau_echelon})</td>
                                        <td className="p-2">{h.nouveau_indice}</td>
                                        <td className="p-2">{new Date(h.date_changement).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="flex justify-end mt-4">
                            <button onClick={() => setShowHistoriqueModal(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Fermer</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}